<template>
  <main-sidebar-item-child-title :title="title" />
  <main-sidebar-item-child
    v-for="(child, i) in mappedLinks"
    :key="i"
    :component-props="child"
  />
</template>

<script setup lang="ts">
import { computed } from '@/composition/vue/compositionApi'
import MainSidebarItemChildTitle from '@/components/layout/mainSidebar/mainSidebarItemChild/MainSidebarItemChildTitle.vue'
import MainSidebarItemChild, {
  type MainSidebarItemChildComponentProps,
} from '@/components/layout/mainSidebar/mainSidebarItemChild/MainSidebarItemChild.vue'
import type {
  PageContentSidebarLink,
  PageContentSidebarSimpleItem,
} from '@/components/layout/pageContent/sidebar/types'

const props = defineProps<{
  title: string
  links: Array<PageContentSidebarLink | PageContentSidebarSimpleItem>
}>()

const mappedLinks = computed(() =>
  props.links.map<MainSidebarItemChildComponentProps>((t) => {
    return {
      itemType: 'link',
      title: t.title,
      route: t.itemType === 'link' ? t.route : undefined,
      badge: t.badge,
      rightIcon: t.rightIcon,
    }
  }),
)
</script>
